import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, ArrowRight } from "lucide-react";
import { CopyButton } from "./shared";

export function TranslatorPanel({ id, title, subtitle, placeholder, actionLabel, onTranslate, accent }) {
  const [text, setText] = useState("");
  const [result, setResult] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!text.trim()) return;
    setBusy(true);
    const out = await onTranslate(text);
    setBusy(false);
    if (out != null) {
      setResult(out);
      setText("");
    }
  };

  const onKey = (e) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) run();
  };

  return (
    <div className="border-2 border-black bg-white flex flex-col" data-testid={`translator-panel-${id}`}>
      <div className={`px-4 py-3 border-b-2 border-black ${accent ? "bg-[#E63946] text-white" : "bg-black text-white"}`}>
        <div className="font-display font-bold text-sm">{title}</div>
        <div className="text-[11px] opacity-80">{subtitle}</div>
      </div>
      <div className="p-4 space-y-3 flex-1 flex flex-col">
        <Textarea
          rows={5}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={onKey}
          placeholder={placeholder}
          className="rounded-none border-black resize-none"
          data-testid={`translator-${id}-input`}
        />
        <button
          onClick={run}
          disabled={busy || !text.trim()}
          data-testid={`translator-${id}-submit`}
          className="inline-flex items-center justify-center gap-2 h-10 bg-black text-white text-xs font-semibold uppercase tracking-wider hover:bg-[#E63946] transition-colors disabled:opacity-40"
        >
          {busy ? <Loader2 className="animate-spin" size={14} /> : <ArrowRight size={14} />} {busy ? "Traduciendo…" : actionLabel}
        </button>
        <div className="border border-dashed border-zinc-400 p-3 min-h-[90px] bg-zinc-50 flex-1" data-testid={`translator-${id}-result`}>
          {result ? (
            <>
              <p className="text-sm whitespace-pre-wrap">{result}</p>
              <div className="mt-3"><CopyButton text={result} testId={`translator-${id}-copy`} /></div>
            </>
          ) : (
            <p className="text-xs text-zinc-400">La traducción aparecerá aquí.</p>
          )}
        </div>
      </div>
    </div>
  );
}
